export const messages = {
    //! header
    AboutUsTitleMainPage: "AboutUs",
    headerMainPage: "Main Page",
    headerServices: "Services",
    headerChart: "Chart",
    headerPrice: "Price Inquiry",
    headerNews: "News",
    headerFAQ: "FAQ",
    headerGallery: "Gallery",
    headerAboutUs: "About Us",
    headerConcatUs: "Contact Us",

    //! Home
    //? services
    servicesTitleMainPage: "Services",
    servicesMainPage1: 'Freight Forwarding and Rail Transportation Services in Active Countries',
    servicesMainPage2: 'Obtaining All Transport Agreements and Required Goods Documents from Transit Countries',
    servicesMainPage3: 'Handling Customs Clearance and Matters Pertaining to the Chamber of Commerce',
    servicesMainPage4: 'Specialized Consultation and Providing the Best and Most Cost-Effective Transit Route',
    servicesMainPage5: 'Rail Cargo Transit through Iran and Central Asian Countries',

    //? Statistics
    statisticsTitleMainPage: 'Statistics for the Year 2023',
    statistics1: 'Export Goods Tonnage',
    statistics2: 'Dollar Value',
    statistics3: 'Number of Wagons',

    //? Benefits
    benefitsTitleMainPage: "Competitive Advantages of the Altyn Logistics Group",
    benefitsCardTitle1: "High-Speed Transportation",
    benefitsCardTitle2: "Assurance of Safe Loading and Transportation of Goods",
    benefitsCardTitle3: "Multiple Trusted and Reputable Key International Partners",
    benefitsCardTitle4: "Smart Tracking and Monitoring of Shipments in All Transit Countries",
    benefitsCardTitle5: "Specialized Personnel for Unloading, Loading, and Customs Clearance Processes",
    benefitsCardTitle6: "Assurance of Safe Delivery of Goods at Destination",
    benefitsCardTitle7: "Expert Advice for Clients and Exporters",
    benefitsCardTitle8: "Allocation of High-Quality Railcars at the Best Price",
    benefitsCardTitle9: "Capability to Pay Invoices in All Regional Countries with Various Payment Methods",
    benefitsCardTitle10: "Intelligent Use of Information Technology in Process Management and Specialized Customer Services",

    //? SelectedImagegallery
    selectedImageGalleryTitleMainPage: "Selected Image Gallery",


    //! FAQ
    //? AccordionQuestionAnswer
    accordionQAs: [
        {
            id: 1,
            question: `How can I rent a railcar for exporting my shipment to Central Asian countries or Afghanistan?`,
            answer: `First, the client should submit their request to Altyn Group's customer service department. If they're in Iran, they can call 09025613535 to reach Engineer Ehsan Vakili (Chief Logistics Officer), or 09032218538 to speak with Engineer Asaf Nazarian (Customer Affairs Manager). They can also submit their request through the website, specifying the type of cargo, approximate tonnage, transportation conditions, and a phone number for follow-up. This request is quickly processed by customer service experts, and the result is communicated to the applicant.`,
        },
        {
            id: 2,
            question: 'How are transportation costs for export cargo calculated?',
            answer: `These costs include unloading and loading from trucks to railcars at the departure station, securing cargo on the railcars, customs clearance fees, payments for Iranian Railways bills of lading, route code fees (permission for railcars to pass through transit countries), rail tariffs in the departure country and transit countries, and additional costs like laboratory and quarantine fees. The costs vary depending on the type of railcar, type of cargo, transit countries, route length, and how the cargo is secured. To get an accurate estimate of transportation costs, you can use the price inquiry function on this site. Note that customs clearance and truck transportation from the factory or point of origin to the Incheh Borun (or Gorgan or Bandar Turkman) rail stations are additional costs and the client's responsibility.`,
        },
        {
            id: 3,
            question: 'From which rail stations in Golestan Province can I export my goods?',
            answer: `Clients can request that their export cargo be shipped from Incheh Borun, Gorgan, or Bandar Turkman stations. They should ensure their cargo is trucked to the loading station on a specific day previously agreed upon with the customer service department. The cargo must meet standard packaging requirements to avoid damage during transit. However, based on customer requests, the transport company can apply special packaging and custom cargo securing methods.`,
        },
        {
            id: 4,
            question: 'What are the responsibilities of the transport company and the exporter?',
            answer: `The exporter must ensure that the trucks carrying the cargo are dispatched to the loading station on the scheduled day. Proper packaging and timely dispatch based on the type of export cargo are crucial to avoid issues when loading goods into railcars. Clients must send trucks with tightly packaged goods first to ensure smooth cargo stacking in the railcar. Additionally, clients must make full payment for the shipping costs before the railcar leaves the station. In specific cases and after obtaining the necessary credit with the company, clients can partially pay and still proceed with railcar dispatch. The forwarding company is responsible for unloading from trucks into railcars, providing invoices, and applying proper cargo securing. The forwarding company also offers tracking and monitoring services to allow clients to check the status of their wagons daily and plan for customs clearance at the destination.`,
        },
        {
            id: 5,
            question: `What services can Altyn Logistics' website offer clients?`,
            answer: `Altyn Logistics' website (www.AltynLogistics.com) provides features such as submitting requests, receiving consultation, wagon tracing, customer billing with full wagon shipment details, and more. Through the Altyn portal, clients can monitor the loading process in real-time, view a breakdown of their costs, and make specific requests for the loading and unloading teams.`
        },
        {
            id: 6,
            question: 'Is it possible for the exporter’s representative to be present at the loading station?',
            answer: `Yes, with proper authorization from customs and the railway, the forwarding company can allow the exporter's representative to be present at the loading station. The representative can then supervise the loading process and inventory count in person.`,
        },
        {
            id: 7,
            question: 'How much cargo can usually be loaded into a railcar? Is it possible to load a variety of goods?',
            answer: `Typically, enclosed railcars can accommodate up to 68 tons of cargo, but this can vary depending on the size and packaging of the goods. The type of railcar also affects the total volume and tonnage of export shipments. Generally, the capacity of an enclosed railcar is equivalent to three semi-trailer trucks, allowing a variety of goods to be loaded as long as they meet export conditions and are not restricted by customs.`,
        },
        {
            id: 8,
            question: 'Does the transport company have any responsibility for customs clearance at the destination?',
            answer: `The transport company is only responsible for ensuring the safe arrival of cargo at the destination station, while customs clearance and railcar unloading are the client's or recipient's responsibility.`,
        },
    ],

    //! AboutUS
    aboutUsCards: {
        rajabGazaqh: {
            name: 'Rajab Ghazagh',
            languages: ['Persian', 'Kazakh', 'Turkish', 'Azeri', 'Turkmen'],
            extra: 'Honorable President of Altyn Group',
        },
        ehsanVakili: {
            name: 'Ehsan Vakili',
            role: 'Senior CEO',
            languages: ['Persian', 'Turkmen'],
            location: 'Gorgan central office',
            description: [
                `The origins of Altyn Group can be traced back to when Altyn Rail Golestan set up operations at the Incheh Borun border station in Iran, providing services to esteemed traders and taking full responsibility for all transport and customs clearance processes. As the first established and registered company at the Incheh Borun railway station, it has become the most well-equipped forwarding company and the most specialized firm ready to deliver a complete range of services. These accolades, along with numerous other achievements, are prominent milestones in the history of Altyn Group.`,
                `Altyn Group takes great pride in being the first and the best in the industry. The long-standing, continuous, and stable cooperation with its loyal customers is a testament to the quality of services offered by Altyn Group, and it will continue to serve as proof of the company's commitment to excellence.`,
            ],
        },
        naghimeChamani: {
            name: 'Naghime Chamani',
            role: 'Senior CEO',
            languages: ['Persian', 'Kazakh'],
            location: 'Iran - Golestan - Gorgan - Shahid Beheshti St',
            description: [
                `Fully addressing customer needs has been the primary goal of Altyn Group from the very beginning until now. The purpose of establishing Altyn Miras Golestan was to expand the company's services and cover more of the needs of customers in the region. Increasing interactions with government organizations and agencies, especially the Ports and Maritime Organization of the Islamic Republic of Iran, providing diverse transportation services, obtaining necessary permits for transit, and covering other service gaps in the region are among the services that Altyn Miras Golestan offers to customers and other companies.`,
            ],
        },
        safarAraghbai: {
            name: 'Sapar Ariqbay',
            role: 'Senior CEO',
            languages: ['Russian', 'Persian', 'Kazakh', 'Turkmen'],
            location: 'Iran - Golestan - Incheh Borun',
            description: [
                `The origins of Altyn Group can be traced back to when Altyn Rail Golestan set up operations at the Incheh Borun border station in Iran, providing services to esteemed traders and taking full responsibility for all transport and customs clearance processes. As the first established and registered company at the Incheh Borun railway station, it has become the most well-equipped forwarding company and the most specialized firm ready to deliver a complete range of services. These accolades, along with numerous other achievements, are prominent milestones in the history of Altyn Group.`,
                `Altyn Group takes great pride in being the first and the best in the industry. The long-standing, continuous, and stable cooperation with its loyal customers is a testament to the quality of services offered by Altyn Group, and it will continue to serve as proof of the company's commitment to excellence.`,
            ],
        },
        asefNazerian: {
            name: 'Asef Nazerian',
            role: 'Senior CEO',
            languages: ['Persian', 'English', 'Turkmen'],
            location: 'Iran - Golestan - Gorgan - Shahid Beheshti St',
            description: [
            ],
        },
        boranBayeva: {
            name: 'Boranbayeva Gulnara Zharylkasynovna',
            role: 'Senior CEO',
            languages: ['Russian', 'Kazakh'],
            location: 'Kazakhstan, Shymkent, Abai region',
            description: [
                `In the world of logistics, there are many gaps and disparities that create problems and obstacles for individuals and companies operating in the region. This company, with a comprehensive understanding of these gaps, aims to build a strong and reliable bridge between companies and active individuals in the region's countries to expedite and improve transportation processes. This chain is strengthened and sustained through direct and specialized connections among the various companies within the Altyn Group.`,
                `Offering route codes, providing wagons, facilitating backhaul loads for regional wagons, especially from within Iran, tracking and tracing shipments, issuing travel permits, and more are among the valuable services reliably and officially provided to customers and other companies in the region.`
            ],
        },
        berdinazarOvezov: {
            name: 'BerdinazarOvezov',
            role: 'Senior CEO',
            languages: ['Persian', 'Turkmen', 'English', 'Russian', 'German'],
            location: "Turkmenistan, Ashgabat, 182 Antalyp Street",
            description: [
                `Turkmenistan, with its strategic geographical location, membership in the CIS countries, strong and developing rail infrastructure, borders with nations such as Kazakhstan and Iran, and access to the Caspian Sea, stands as one of the most promising and attractive logistics hubs in the region for transport operators. In line with Altyn Group's strategic objectives, the establishment of Altyn Hayat in Turkmenistan has become a reality. Through direct connections with Turkmenistan's railways and government agencies, offering wagons, tracking and tracing shipments sent through and across Turkmenistan, and handling transit wagons are among the services that Altyn Hayat provides to customers, leveraging the interconnected infrastructure of the Altyn Group.`,
            ],
        },
        abdazizSakhi: {
            name: 'Abdul aziz Sakhi',
            role: 'Senior CEO',
            languages: ['Persian, Dari'],
            location: 'Afghanistan, Kabul, Najaran Fort, District 11',
            description: [
                `Given the strategic assessment and the critical logistical hubs of Afghanistan in Aqina, Torghundi, Khaf, and Herat, Altyn Group has deemed it crucial to establish its presence in these areas. This enables the provision of forwarding and trading services, among others, to better support its customers and business partners. Another achievement by Altyn Group is the direct collaboration with the Afghanistan Railway Authority and Afghan government agencies, allowing for reliable and direct services in these hubs for its business partners and valued customers.`,
            ],
        },
        hamedAbbasi: {
            name: 'Hamed Abbasi',
            role: 'Senior CEO',
            languages: ['Persian', 'English'],
            location: 'Iran - Golestan - Gorgan - Shahid Beheshti St',
            description: [
                `Altyn Digital Technology Company, born from the heart of the logistics world, utilizes computer science and programming to address the concerns of transportation industry professionals and practitioners. The company's vision is to establish an integrated transportation system in the region, beginning with services provided to the Altyn Group companies. By merging technology with logistics, the company is steadily moving toward its goal. For example, providing services for transportation system automation, tracking and monitoring in-transit wagons and containers, and offering other modern infrastructure to traders, wagon owners, forwarders, and more are among the valuable services offered by this company.`,
            ],
        },
    },

    //? CompanyInfoCard
    languages: 'languages',
    contactInfo: 'contact information',
    description: 'description',

    //! ContactUs
    contactUsPersonTitle: 'Contacts',
    contactUsNumberstitle: 'Be in touch with us',

    //? contact us cards
    contactUsCards: {
        rajabGazaqh: {
            name: 'Rajab Ghazagh',
            extra: 'Honorable President of Altyn Group',
        },
        ehsanVakili: {
            name: 'Ehsan Vakili',
            role: 'Senior CEO',
            location: 'Gorgan central office',
        },
        naghimeChamani: {
            name: 'Naghime Chamani',
            role: 'Senior CEO',
            location: 'Iran - Golestan - Gorgan - Shahid Beheshti St',
        },
        boranBayeva: {
            name: 'Boranbayeva Gulnara Zharylkasynovna',
            role: 'Senior CEO',
            location: 'Kazakhstan, Shymkent, Abai region',
        },
        berdinazarOvezov: {
            name: 'BerdinazarOvezov',
            role: 'Senior CEO',
            location: "Turkmenistan, Ashgabat, 182 Antalyp Street",
        },
        abdazizSakhi: {
            name: 'Abdul aziz Sakhi',
            role: 'Senior CEO',
            location: 'Afghanistan, Kabul, Najaran Fort, District 11',
        },
        hamedAbbasi: {
            name: 'Hamed Abbasi',
            role: 'Senior CEO',
            location: 'Iran - Golestan - Gorgan - Shahid Beheshti St',
        },
        safarAraghbai: {
            name: 'Safar Araghbai',
            role: 'assignment',
            location: 'Gorgan central office',
        },
        aminMohammadGoog: {
            name: 'Amin Mohammad Goog',
            role: 'Inche Bron branch manager',
            location: 'Inche Bron railway station',
        },
        soroshMaghsodi: {
            name: 'Sorosh Maghsodi',
            role: 'Accounting',
            location: 'Gorgan central office',
        },
        molamBardiGoog: {
            name: 'Molam Bardi Goog',
            role: 'Inche Bron operational',
            location: 'Inche Bron railway station',
        },
        shahabKaslakhe: {
            name: 'Shahab Kaslakhe',
            role: 'customs',
            location: 'Inche Bron railway station',
        },
    },

    //! ServicesAltynRail
    services: [
        {
            title: 'Rail Services',
            para: [
                `Altyn Group has always aimed to play a larger role in regional logistics. For example, Altyn Logistics KZ, based in Kazakhstan, monitors and controls shipments to other countries. After shipping the railcars, the freight is received by Altyn Afghan and, following unloading, is transferred to Altyn Hayat. Once Altyn Hayat completes its part, Altyn Rail or Altyn Miras takes over. At the Incheh Borun border station, the goods are reloaded and sent to the mainland as freight. This process offers a win-win situation: it reduces costs for wagon owners, lowers freight transport costs in the region, and ultimately offers merchants fewer worries, higher quality, and lower costs.`,
            ],
        },
        {
            title: 'Operational Services',
            para: [],
        },
        {
            title: 'Quality Assurance for Unloading and Loading Processes at Origin Stations',
            para: [
                `Altyn Logistics Group has assembled and trained a team of top professionals to handle the unloading of export goods from trucks and loading them onto railcars for dispatch. This team ensures quality throughout the process. With Altyn Group, the most advanced company at the Incheh Borun station, you can rest assured that loading problems will not be a concern. Trust us with your valuable goods, and you will be satisfied with the quality of the work. Our ongoing cooperation with our long-standing customers is a testament to this claim.`,
                `Altyn Logistics Group is a skill-based organization that takes great pride in its competent workforce.`,
            ],
        },
        {
            title: 'Route Codes and Transport Permits',
            para: [
                `One of the challenges for forwarders and merchants in rail transport is obtaining route codes for transit countries.`,
                `One of the goals of Altyn Group's presence in the Commonwealth of Independent States (CIS) countries is to provide route codes and obtain the necessary permits for transit through each country. By working constructively with governmental agencies in the transit countries, Altyn Group facilitates the rapid acquisition of the required permits.`,
                `We are proud to announce that Altyn Logistics KZ, located in Kazakhstan's Shymkent, is ready to offer expedited forwarding services. Altyn Hayat operates in Turkmenistan, Altyn Afghan in Afghanistan, and Altyn Rail and Altyn Miras in Iran, providing customers with the confidence that their shipments will transit the region without issues and will be fully monitored by Altyn Group representatives.`,
            ],
        },
        {
            title: 'Customs Clearance',
            para: [
                `To improve its quality standards, Altyn Group employs experienced and proficient specialists and standard protocols for customs clearance and the release of merchants' goods. The company has always aimed to clear customers' goods as quickly as possible, with the honor of achieving "same-day release and shipment." Our track record in this service has always been a source of strength and pride for Altyn Group.`,
            ],
        },
        {
            title: 'Logistics Consulting',
            para: [
                `The management team at Altyn Group, with its extensive experience and expertise, consists of skilled professionals who conduct periodic analyses of key logistics parameters. They are ready to provide logistics and commercial consulting to reduce risks and improve trade security. This team has comprehensive knowledge of the region and evaluates all available options to help you make the best choice. Our consultants are available by phone, social media, or through the Altyn Logistics website to address your needs. Even if you've never exported goods before, the Altyn Group consultants will guide you through this complex journey. Altyn Logistics Group will bring you peace of mind.`,
            ],
        },
        {
            title: 'Technology',
            para: [
                `Today, technology is an integral part of industry and business processes. Altyn Group, through its subsidiary Altyn Digital Technology, seeks to engineer logistics processes with a comprehensive understanding of the transportation industry's concerns. By employing engineers and programmers, we have created a platform for common tools. With Altyn Group, you will access a wide range of online services. These include wagon tracking, monitoring the loading and unloading process, online invoicing, and many other services.`,
            ],
        },
    ],

    chartTitle: 'Organization chart',

    emptyGallery: ' Gallery is empty',
    galleryTitle: 'gallery title : ',












    Lorem100: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    Lorem10: "Lorem Epsom is a fictional text produced with incomprehensible simplicity from the printing industry, and using graphic designers, printers and texts but also newspapers and graphics.",
    MoreDetailsButton: 'More Details',
    ServicesTitleMainPage: "Services",
    RailroadTransportationCardTitle: "Rail Transportation",
    MaritimeTransportationCardTitle: "Maritime Transportation",
    RoadTransportationCardTitle: "Road Transportation",
    ReadMore: "Read More",
    AltynBenefitsTitleMainPage: "Altyn Benefits",
    AltynBenefitsCardTitle: "High-speed Transportation",
    LastNewsTitleMainPage: "Latest News",
    TitleInformationCardNewsRoad: "National Strategic Economic Exchange Session Along the Silk Road",
    TitleInformationCardNewsAirPlane: "Proposal to Import Aircraft Over 20 Years Old to Iran",
    TitleInformationCardNews: "{title}",
    CompanyLocation: "Golestan, Gorgan, Baharestan Street",
    AlertSubFooter: "All rights reserved by Altyn Group",
    DesignBySubFooter: "Designed and Developed by Altyngroup",
    LoremTitle: 'Lorem Ipsum is a fictional text',
    HeaderGallery: "Gallery",


    //main page ended

    AirTransportationTitleServices: "Air Transportation",
    ImportsAndExportsTitleServices: "Imports and Exports",
    ClearanceTitleServices: "Customs Clearance",
    TitleOfTheTransportsServices: "{title} Service by Altyn",
    CapacityOfAltynTransportationServices: "Capacities of {title} Service by Altyn",
    CapacityOfAltynTransportationServicesTitle: "{title}",
    AltynRailTransportServiceCapacities: ' Capacity of Altyn Rail Transport Service',
    AltynRoadTransportServiceCapacities: 'Capacity of Altyn Road Transport Service',
    CapacitiesOfAltynAirTransportService: ' Capacity of Altyn Air Transport Service',
    AltynImportAndExportServiceCapacities: ' Capacity of Altyn Import and Export Service',
    AltynClearanceServiceCapacities: ' Capacity of Altyn Clearance Service',
    CapacitiesofAltynSeaTransportationService: 'Capacities of Altyn Sea Transportation Service',


    //end Services Page

    EnterInformationToInquireAboutThePrice: "Enter Information to Inquire About the Price",
    FirstAndLastNameInputLabel: "First and Last Name",
    PhoneNumberInputLabel: "Phone Number",
    EmailInputLabel: "Email",
    CargoNameInputLabel: "Cargo Name",
    HsCodeInputLabel: "HsCode",
    CargoTonnageInputLabel: "Cargo Tonnage",
    OriginInputLabel: "Origin",
    DestinationInputLabel: "Destination",
    MultiRouteInputLabel: "Is the Cargo Multi-route?",
    DegreeOfRiskOfTheGoodsInputLabel: "Degree of Risk of the Goods",
    PackageTypeInput: "Package Type",
    IsTheShipmentDeclared: "Is the Shipment Declared?",
    Yes: "Yes",
    No: "No",
    SendButtonTitle: "Send",
    AlertPricePage: "Our experts will contact you after necessary evaluations.",
    TehranIranTitle: "Tehran, Iran",
    EsfehanIranTitle: "Isfahan, Iran",
    TabrizIranTitle: "Tabriz, Iran",
    singleTrackTitle: "Single Track",
    TwoPaths: "Two Paths",
    ThreePaths: "Three Paths",
    LevelOne: "Level One",
    LevelTwo: "Level Two",
    LevelThree: "Level Three",
    Carton: "Carton",
    CardBoard: "Cardboard",
    Plastic: "Plastic",
    NameYup: 'Full name is required.',
    PhoneYupNumber: 'Phone number must be numeric.',
    PhoneYupCh: 'Phone number must be exactly 11 characters.',
    PhoneYup: 'Phone number is required.',
    EmailYup: 'Invalid email address.',
    EmailYupIN: 'Email address is required.',
    ProductYup: 'Product name is required.',
    CodeYup: 'HS code is required.',
    TonnageYup: 'Tonnage of the shipment is required.',
    TonnageYupNumber: 'Tonnage must be numeric.',
    OriginYup: 'Origin is required.',
    DestinationYup: 'Destination is required.',
    RoadYup: 'Type of route is required.',
    GradeYup: 'Risk level is required.',
    TypeYup: 'Packaging type is required.',


    //end price page

    TitleNewsPage: "Altyn Group News",

    //end NewsPage

    TitleAboutUsPage: "About Altyn Transportation Group",
    SubcategoriesOfAltynGroup: "Subcategories of Altyn Group",
    ViewServicesButton: "View Services",
    AltynHeritage: 'Altyn Heritage',


    //end AboutUs Page
    ContactUs: 'Contact Us',

    PhoneNumbers: "Phone Numbers:",
    WhatsAppAndTelegram: "WhatsApp and Telegram:",
    SocialMedia: "Social Media:",
    mapLocation: "Altyn Headquarters Location on Map",

    //end Contact us

    HomeAndNews: "Home/News/",
    Pm: 'P.m',
    Am: 'A.m'
};
